<div class="table-row row-hover">
    <div class="row py-2 align-items-start" (click)="isCollapsed = !isCollapsed">
        <div class="col-1 d-flex justify-content-center align-items-start">
            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        @for (column of columns; track column) {
            <div
                class="text-break col-lg-3 col-5"
                [ngClass]="{ 'text-danger': pIMeasurementToolExpandableForm.invalid }"
            >
                {{
                    get(column.field).length > 0
                        ? get(column.field)
                        : ('PHYSICAL_INVENTORY_NEW_ENTRY_LABEL' | translate) + ' ' + column.title
                }}
            </div>
        }
    </div>
    <!-- Intentionally using [hidden] instead of *ngIf to avoid re-creation and to display titles correctly based on validation results -->
    <div [hidden]="isCollapsed" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="tool-description"
                [translate]="'PHYSICAL_INVENTORY_DESCRIPTION_LABEL'"
            ></label>
            @if (row.isEntryDeletable) {
                <div class="col-lg-3 col-11 offset-1 offset-lg-0 mb-3">
                    <pace-core-text-input
                        id="tool-description"
                        [(model)]="row.equipmentDesc"
                        (valueChange)="updateRowValidation()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_DESCRIPTION_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-3 offset-1 offset-lg-0 col-11 text-start py-2" for="tool-description">{{
                    row.equipmentDesc.value
                }}</label>
            }
            <label
                class="col-lg-1 offset-1 offset-lg-0 col-11 col-form-label text-start text-lg-end"
                for="tool-equipment-no"
                [translate]="'PHYSICAL_INVENTORY_MEASUREMENT_TOOL_EQUIPMENT_NO_LABEL'"
            ></label>
            @if (row.isEntryDeletable) {
                <div class="col-lg-3 offset-1 offset-lg-0 col-11 mb-3">
                    <pace-core-text-input
                        id="tool-equipment-no"
                        [(model)]="row.equipNo"
                        (valueChange)="updateRowValidation()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_MEASUREMENT_TOOL_EQUIPMENT_NO_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-3 col-11 offset-1 offset-lg-0 text-start py-2" for="tool-equipment-no">{{
                    row.equipNo.value
                }}</label>
            }
        </div>
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="tool-material-no"
                [translate]="'PHYSICAL_INVENTORY_MATERIAL_NO_LABEL'"
            ></label>
            @if (row.isEntryDeletable) {
                <div class="col-lg-3 col-11 offset-1 offset-lg-0 mb-3">
                    <pace-core-text-input
                        id="tool-material-no"
                        [(model)]="row.materialNo"
                        (valueChange)="updateRowValidation()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_MATERIAL_NO_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-3 col-11 offset-1 offset-lg-0 text-start py-2" for="tool-material-no">{{
                    row.materialNo.value
                }}</label>
            }
            <label
                class="col-lg-1 col-11 offset-1 offset-lg-0 col-form-label text-start text-lg-end"
                for="tool-serial-no"
                [translate]="'PHYSICAL_INVENTORY_MEASUREMENT_TOOL_SERIAL_NO_LABEL'"
            ></label>

            <div class="col-lg-3 col-11 offset-1 offset-lg-0 mb-3">
                <pace-core-text-input
                    id="tool-serial-no"
                    [(model)]="row.serialNo"
                    (valueChange)="updateRowValidation()"
                    [parentForm]="formChildren"
                    [ariaLabel]="'PHYSICAL_INVENTORY_MEASUREMENT_TOOL_SERIAL_NO_LABEL' | translate"
                >
                </pace-core-text-input>
            </div>
        </div>
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="tool-radio-check"
                [translate]="'PHYSICAL_INVENTORY_MEASUREMENT_TOOL_RADIO_LABEL'"
            ></label>
            <div class="col-lg-3 col-11 offset-1 offset-lg-0 py-1">
                <pace-core-radio-input
                    id="tool-radio-check"
                    [(model)]="row.ynFlagRadioModel"
                    (valueChange)="updateRowValidation()"
                    [parentForm]="formChildren"
                >
                </pace-core-radio-input>
            </div>
        </div>
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="tool-comments"
                [translate]="'PHYSICAL_INVENTORY_COMMENTS_LABEL'"
            >
            </label>
            <div class="col-lg-5 col-11 offset-1 offset-lg-0 mb-3 py-1">
                <pace-core-text-input
                    id="tool-comments"
                    [(model)]="row.comments"
                    [parentForm]="formChildren"
                    [ariaLabel]="'PHYSICAL_INVENTORY_COMMENTS_LABEL' | translate"
                >
                </pace-core-text-input>
            </div>
            <br />
            @if (row.isEntryDeletable) {
                <div class="col-1 offset-11 offset-lg-4 mb-3 py-1">
                    <button
                        class="w-20 btn btn-warning float-end"
                        type="button"
                        [attr.aria-label]="'PHYSICAL_INVENTORY_DELETE_ENTRY_ARIA_LABEL' | translate"
                        (click)="deleteMeasurementToolRow()"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </div>
            }
        </div>
    </div>
</div>
